import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { groupApi } from '../../../core/api/rtk-query/group.api';
import { userApi } from '../../../core/api/rtk-query/user.api';

const Backdrop = styled.div`position: fixed; inset: 0; background: rgba(0,0,0,0.4); display: grid; place-items: center; z-index: 500; overflow-y: auto; padding: 20px;`;
const Modal = styled.div`width: 720px; max-width: 100%; background: #fff; border-radius: 16px; padding: 24px; box-shadow: 0 16px 48px rgba(0,0,0,0.12); margin: auto;`;
const Input = styled.input`padding: 10px 12px; border-radius: 10px; border: 1px solid #dbe3f6; background: #fff; width: 100%; box-sizing: border-box;`;
const Btn = styled.button`background: #fff; border: 1px solid #dbe3f6; color: #0b1221; padding: 8px 12px; border-radius: 10px; cursor:pointer;`;
const Row = styled.div`display: flex; gap: 8px; align-items: center;`;
const UserList = styled.div`max-height: 400px; overflow-y: auto; border: 1px solid #e5e8f0; border-radius: 12px; margin-top: 12px;`;
const UserRow = styled.div`display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; border-bottom: 1px solid #eef1f6; &:last-child { border-bottom: none; }`;

type Props = { group: { id: string; name: string }; onClose: () => void };

export const GroupTeacherModal = ({ group, onClose }: Props) => {
  const pageSize = 100;
  const [pageNumber] = useState(1);
  const { data: membersPage, refetch: refetchMembers } = groupApi.useGetUsersInGroupQuery({ groupId: group.id, pageNumber, pageSize });
  
  const [searchQuery, setSearchQuery] = useState('');
  const [triggerSearch] = userApi.useLazySearchUsersQuery();
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [addUserToGroup] = groupApi.useAddUserToGroupMutation();
  const [removeUserFromGroup] = groupApi.useRemoveUserFromGroupMutation();

  useEffect(() => {
    const timeout = setTimeout(async () => {
      const q = searchQuery.trim();
      if (!q) { setSearchResults([]); return; }
      const isNum = /^\d+$/.test(q);
      const tasks: Promise<any>[] = [];
      tasks.push(triggerSearch({ name: q, role: 'Teacher', pageNumber: 1, pageSize: 25 }).unwrap());
      tasks.push(triggerSearch({ email: q, role: 'Teacher', pageNumber: 1, pageSize: 25 }).unwrap());
      if (isNum) tasks.push(triggerSearch({ isuNumber: Number(q), role: 'Teacher', pageNumber: 1, pageSize: 25 }).unwrap());
      const settled = await Promise.allSettled(tasks);
      const merged: Record<string, any> = {};
      settled.forEach(r => { if (r.status === 'fulfilled') for (const u of (r.value?.users || [])) merged[u.id] = u; });
      setSearchResults(Object.values(merged));
    }, 300);
    return () => clearTimeout(timeout);
  }, [searchQuery, triggerSearch]);

  const teachers = (membersPage?.users || []).filter((u: any) => u.role === 'Teacher');

  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <Row style={{ justifyContent: 'space-between', marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>Преподаватель потока: {group.name}</h3>
          <Btn onClick={onClose}>Закрыть</Btn>
        </Row>

        <div>
          <div style={{ fontSize: 12, color: '#465676', marginBottom: 6 }}>Поиск преподавателей для добавления</div>
          <Input placeholder="Имя, почта или ИСУ..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
          {searchQuery && searchResults.length > 0 && (
            <UserList>
              {searchResults.map(u => (
                <UserRow key={u.id}>
                  <div>
                    <div style={{ fontWeight: 500 }}>{u.name}</div>
                    <div style={{ fontSize: 12, color: '#667' }}>ИСУ: {u.isuNumber} | {u.email}</div>
                  </div>
                  <Btn onClick={async () => { await addUserToGroup({ userId: u.id, groupId: group.id }).unwrap(); await refetchMembers(); setSearchQuery(''); }}>Добавить</Btn>
                </UserRow>
              ))}
            </UserList>
          )}
        </div>

        <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid #e5e8f0' }}>
          <h4 style={{ margin: '0 0 12px 0' }}>Список преподавателей ({teachers.length})</h4>
          <UserList>
            {teachers.map((u: any) => (
              <UserRow key={u.id}>
                <div>
                  <div style={{ fontWeight: 500 }}>{u.name}</div>
                  <div style={{ fontSize: 12, color: '#667' }}>ИСУ: {u.isuNumber} | {u.email}</div>
                </div>
                <Btn onClick={async () => { await removeUserFromGroup({ userId: u.id, groupId: group.id }).unwrap(); await refetchMembers(); }}>Удалить</Btn>
              </UserRow>
            ))}
            {teachers.length === 0 && <div style={{ padding: 12, color: '#667', textAlign: 'center' }}>Нет преподавателей</div>}
          </UserList>
        </div>
      </Modal>
    </Backdrop>
  );
};
